// extracted by mini-css-extract-plugin
export default {"main":"main--Wj5qq","error":"error--Xb2NK"};